const Active = '433a217a-9ff0-420e-9ed0-1668a38213aa'
const Deleted = '874d47cb-fb36-43a8-8b3a-05f658e2a17d'
const Archived = '627d5880-a40d-4626-8e0c-4ee22d7d6ff7'
export { Active, Deleted, Archived }
